var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 20.6c-.2 0-.3 0-.5-.1L12 18.1l-4.5 2.4c-.3.2-.7.1-1.1-.1-.3-.2-.5-.6-.4-1l.9-5-3.6-3.5c-.3-.2-.4-.6-.3-1 .1-.4.4-.6.8-.7l5-.7L11 4c.2-.3.5-.6.9-.6s.7.2.9.6L15 8.5l5 .7c.4.1.7.3.8.7.1.4 0 .8-.3 1l-3.6 3.5.9 5c.1.4-.1.8-.4 1 0 .1-.2.2-.5.2zM12 16c.2 0 .3 0 .5.1l3.2 1.7-.7-3.5c-.1-.3.1-.7.3-.9l2.5-2.5-3.5-.5c-.3 0-.6-.3-.8-.5L12 6.7l-1.6 3.2c-.1.3-.4.5-.8.5l-3.5.5 2.5 2.5c.3.2.4.5.4.9l-.6 3.5 3.2-1.7c.1-.1.2-.1.4-.1z",
    fill: "#050505"
  })));
}

export default SvgIconStar;